import { render, staticRenderFns } from "./DeptInfo.vue?vue&type=template&id=ce25ef10&scoped=true"
import script from "./DeptInfo.vue?vue&type=script&lang=js"
export * from "./DeptInfo.vue?vue&type=script&lang=js"
import style0 from "./DeptInfo.vue?vue&type=style&index=0&id=ce25ef10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce25ef10",
  null
  
)

export default component.exports